/**
 * Cibles reads that are not the list/search the Targets page already owns
 * (docs/features/targets.md §20.4, §20.7).
 */
import {
  TARGET_LIMITS,
  type TargetCategory,
  type TargetsByIdRequest,
  type TargetsByIdResponse,
} from '@traaker/shared';
import { api, ApiError } from './api';

/** Counters the import worker records once the import has run. Every one is optional. */
export interface TargetImportResult {
  importId: string;
  finishedAt: string;
  mode: string;
  counters: {
    skippedHeldUrl?: number;
    urlOverflow?: number;
    stagedDeduped?: number;
    noStableKey?: number;
    etabNoBranchKey?: number;
    etabAmbiguousKey?: number;
    keptDuplicateKey?: number;
    carried?: number;
    created?: number;
  };
}

export const targetsService = {
  /**
   * Resolve ids to their display fields. The caller passes only what is ON SCREEN; a
   * list longer than the API bound is a caller bug, so it is cut rather than paged —
   * paging here would turn the lookup into the whole-partition read the bound forbids.
   */
  getByIds: (
    brandId: string,
    ids: Array<{ targetId: string; category?: TargetCategory }>,
  ): Promise<TargetsByIdResponse> => {
    const body: TargetsByIdRequest = { ids: ids.slice(0, TARGET_LIMITS.maxTargetsByIdLookup) };
    return api
      .post<TargetsByIdResponse>(`/brands/${brandId}/targets/by-id`, body)
      .then((r) => r ?? { items: [], notFound: [] });
  },

  /** `null` when the worker has not written the result (404) — never an error to show. */
  getImportResult: (brandId: string, importId: string): Promise<TargetImportResult | null> =>
    api
      .get<TargetImportResult>(`/brands/${brandId}/targets/import/${encodeURIComponent(importId)}/result`)
      .catch((err) => {
        if (err instanceof ApiError && err.status === 404) return null;
        throw err;
      }),
};
